import ContactsList from '@/components/contacts-list';
import { useChatContext } from '@/contexts/chat/context';
import type { Contact } from '@/contexts/contacts/types';
import styles from './index.module.scss';

interface ContactsBarProps {
  contacts: Contact[];
}

const ContactsBar = ({ contacts }: ContactsBarProps) => {
  const { createChat, activeChat } = useChatContext();

  const onContactClick = useCallback(
    async (contact: Contact) => {
      const user_ = Object.assign(contact, {
        label: contact.name,
        value: contact.user_id,
        userId: contact.user_id,
      });
      const chat = await createChat({ userId: user_.userId });
      if (chat) {
        activeChat(chat.chat_id);
      }
    },
    [activeChat, createChat]
  );

  return (
    <div className={styles.contactsBar}>
      <ContactsList
        contacts={contacts}
        onContactClick={onContactClick}
        showAlphabetIndex={false}
        isPage
      />
    </div>
  );
};

export default ContactsBar;
